module.exports = "/images/x.svg";